module.exports = __webpack_public_path__ + "img/2025banner_8.369942e8.jpg";